var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93 1113 c-38 -7 -81 -59 -88 -106 -3 -23 -5 -204 -3 -402 3 -316 5 -363 20 -383 24 -35 50 -51 97 -58 l41 -7 2 376 3 376 232 -180 c128 -98 237 -179 243 -179 6 0 115 81 243 179 l232 180 3 -376 2 -376 41 7 c50 8 81 28 100 63 21 39 21 787 0 826 -19 35 -50 55 -98 62 -37 6 -43 2 -278 -184 -132 -105 -242 -191 -245 -191 -3 0 -113 86 -245 190 -149 118 -247 189 -260 189 -11 -1 -30 -4 -42 -6z",
    fill: "#3a291f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.61da49ba3820161a4077d37f9185d63e.svg";
export { ForwardRef as ReactComponent };